import { FlexColumn } from '@/atoms/FlexContainers'
import { CloseIcon } from '@/atoms/Icons/CloseIcon'
import { TitleXS } from '@/atoms/Text'
import { useSafeRouter } from '@/utils/nextUtils/safe-router'
import { useTranslate } from '@/utils/translate/translate-client'
import { Cta } from './Cta'

interface Props {
  handleGiftClick: () => void
  onClose: () => void
  onCopyClick: () => void
  showtimesLink: string
  discountCodes: string[]
}
export const DefaultTicketsStep = ({ handleGiftClick, onClose, onCopyClick, showtimesLink, discountCodes }: Props) => {
  const { t } = useTranslate('common')
  const router = useSafeRouter()
  return (
    <>
      <div className="absolute right-6 top-6 cursor-pointer rounded-full bg-black/10 p-2" onClick={onClose}>
        <CloseIcon color="black" size={16} />
      </div>
      <FlexColumn className="gap-8 pb-6">
        <FlexColumn className="gap-2 text-left md:pr-5">
          <TitleXS weight="semibold" color="black" className="md:photon-title-md pr-8">
            {t('howWouldYouLikeToUseYourGuildTicketsCount', {
              count: discountCodes.length,
              defaultValue_one: 'How would you like to use your Guild ticket?',
              defaultValue_other: 'How would you like to use your {{count}} Guild tickets?',
            })}
          </TitleXS>
        </FlexColumn>
      </FlexColumn>

      <FlexColumn className="gap-2">
        {showtimesLink && (
          <Cta
            imgSrc="/v1747671566/66f3793a962a8c35a4e10d9c535b1836fca8f6e0_oeo88u"
            imgAlt={t('theaterSeats', 'Theater Seats')}
            fromColor="#711601"
            title={t('pickYourSeats', `Pick Your Seats`)}
            subtitle={t('ataTheaterNearYou', `at a Theater Near You`)}
            onClick={() => {
              router.push(showtimesLink)
            }}
          />
        )}
        <Cta
          imgSrc="/v1747671565/8eee7944fec55bc59583a345a780f9b3a20aebe6_ytlcd3"
          imgAlt={t('shareYourTickets', 'Share Your Tickets')}
          fromColor="#330F4D"
          title={t('shareYourTickets', `Share Your Tickets`)}
          subtitle={t('toyourFriendsandFamily', `to your Friends & Family`)}
          onClick={onCopyClick}
        />
        <Cta
          imgSrc="/v1747671565/bde9faf06eb91d6a97d5dab9c6851dc0f85f3a17_r5qq4n"
          imgAlt={t('letAngelGiftThem', 'Let Angel Gift Them')}
          fromColor="#0E7358"
          title={t('letAngelGiftThem', 'Let Angel Gift Them')}
          subtitle={t('andWellGiftThemtoSomeoneDeserving', `and We’ll Gift Them to Someone Deserving`)}
          onClick={handleGiftClick}
        />
      </FlexColumn>
    </>
  )
}
